<!--===========================
=            LOGIN            =
============================-->
<template>
    <main class="transparent">
        <v-parallax dark height="900" src="../../assets/images/theme.jpg">
            <v-card :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'" align="center" justify="center"
                    class="mx-auto" width="500" flat>
                <v-toolbar class="transparent" flat>
                    <v-toolbar-title class="primary--text">
                        Login
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                </v-toolbar>

                <v-divider></v-divider>


                <v-card-text class="mb-10 " style="height: 200px;">
                    <v-form>
                        <v-text-field label="Email Adress" outlined name="login" prepend-icon="person" type="text" />

                        <v-text-field id="password" outlined label="Password" name="password" prepend-icon="lock"
                                      type="password" />

                    </v-form>
                    <v-row align="center" justify="center">
                        <v-btn class="ma-5 rounded-lg white--text" fab color="indigo">
                            <v-icon>mdi-facebook</v-icon>
                        </v-btn>
                        <v-btn class="ma-5 rounded-lg white--text" fab color="cyan">
                            <v-icon>mdi-twitter</v-icon>
                        </v-btn>
                        <v-btn class="ma-5 rounded-lg white--text" fab color="red">
                            <v-icon>mdi-google</v-icon>
                        </v-btn>

                    </v-row>
                </v-card-text>
                <v-card-actions class=" mt-10 pt-10">
                    <v-btn block class=" white--text" @click="login()" color="primary">Login</v-btn>

                </v-card-actions>

                <v-card-actions class="">

                    <v-btn block class=" white--text" @click="register()" color="error">Register</v-btn>

                </v-card-actions>


            </v-card>



        </v-parallax>
    </main>
</template>

<script>
    export default {

        data: () => ({
            rounded: 'lg',
            loading: false,
            drawer: null,
            model: {
                username: "admin@admin.com",
                password: "password"
            },
            agreement: false,
            bio: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts',
            dialog: false,
            email: undefined,
            form: false,
            isLoading: false,
            password: undefined,
            phone: undefined,
            rules: {
                email: v => !!(v || '').match(/@/) || 'Please enter a valid email',
                length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
                password: v => !!(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
                    'Password must contain an upper case letter, a numeric character, and a special character',
                required: v => !!v || 'This field is required',
            },

        }),

        methods: {
            login() {
                this.loading = true;
                setTimeout(() => {
                    this.$router.push("/dashboard/dashboard1");
                }, 1000);
            },
            register() {
                this.loading = true;
                setTimeout(() => {
                    this.$router.push("/pages/page-register");
                }, 1000);
            },

        }
    };
</script>

<style scoped>
    .title-login {
        text-align: center;

    }
</style>
<!--====  End of LOGIN  ====-->